import {
  Loading,
  NullableBooleanInput,
  NumberInput,
  TextInput,
} from 'react-admin'
import Invoice from './invoice'
import Datagrid from './datagrid'
import CollectionData from './collection-data'
import { PrintListButtons } from '../../shared'
import { List, Filter } from '../../custom'
import { withCollectionData } from '../../hoc'
import { useEarliestIncompletePeriod, useLabel } from '../../../hooks'
import PeriodDatePicker from '../../shared/period-date-picker'

const DatagridWithTotals = withCollectionData(Datagrid, CollectionData)

const HourlyTicketsInvoicesFilter = props => {
  const label = useLabel(props)

  return (
    <Filter>
      <PeriodDatePicker label={label('period_end_date')} source='period_end_date_eq' />
      <NullableBooleanInput label={label('is_archived')} source='is_archived_true' />
      <TextInput label={label('customer', 'filter')} source='customer_name_i_cont' />
      <NumberInput label={label('total_line_item_quantity', 'filter', 'greaterThan')} source='total_line_item_quantity_gteq' />
      <NumberInput label={label('total_in_dollars', 'filter', 'greaterThan')} source='total_in_dollars_gteq' />
    </Filter>
  )
}

const Actions = () => {
  return (
    <PrintListButtons
      summary={<DatagridWithTotals/>}
      detail={<Invoice/>}
    />
  )
}

const HourlyTicketInvoicesList = props => {
  const period = useEarliestIncompletePeriod()

  if (!period) return <Loading />

  return (
    <List
      {...props}
      filters={<HourlyTicketsInvoicesFilter />}
      filter={{ include_collection_data: true }}
      actions={<Actions />}
      filterDefaultValues={{ period_end_date_eq: period?.end_date }}
    >
      <DatagridWithTotals />
    </List>
  )
}

export default HourlyTicketInvoicesList
